import React, { Component } from 'react';
import { Icon } from 'antd';
import TableC from '../../basicElement/TableC';
import ConfigColumn from './ConfigColumn';
import format from '../../shared/format';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import cf from '../../../utils/cf';
import fp from '../../../utils/fp';

let type = "INV_SIMPLE_LIST";
const GlobalType = {
    "Global_Multicenter": "全球多中心",
    "Internal_Multicenter": "国内多中心",
    "Internal_Single": "国内单中心管理(区域负责)",
    "Not_Applicable": "不适用",
};
const MedicineType = {
    "Research_drugs": "药物",
    "Technology": "技术类（如细胞技术）",
    "Medical_instruments": "医疗器械",
    "Vaccines": "疫苗",
    "Diagnostic_reagent": "诊断试剂",
    "Others": "其他",
};

class list extends Component {
    constructor(props) {
        super(props);
        this.height = (document.documentElement || document.body).clientHeight - 240;
        this.state = {
            loading: false,
            head: [],
            data: [],
            totalCount: 0,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { searchParams: nextSearchParams } = nextProps;
        const { searchParams } = this.props;
        if (nextSearchParams !== searchParams) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.queryHead();
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.load !== this.props.load) {
            this.loadData();
        }
    }

    queryHead = () => {
        this.setState({ loading: true });
        Fetch.post(API_URL.common.queryUserCustomDisplayByUserId, {
            type
        }).then(res => {
            this.setState({
                loading: false,
                head: res[type],
            }, () => {
                this.loadData();
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    loadData = () => {
        const { activeKey, pagination, sortParams, searchParams } = this.props;
        const { current, pageSize } = pagination;
        const { investigationMedicineType = [] } = searchParams;

        this.setState({ loading: true });
        Fetch.post(API_URL.investigation.queryInvestigationListSimple, {
            offset: current,
            limit: pageSize,
            ...sortParams,
            ...searchParams,
            current: activeKey,
            investigationMedicineType: investigationMedicineType[0],
            secondResearchProductType: investigationMedicineType[1],
        }).then(res => {
            const { datas, totalCount } = res;
            this.setState({
                totalCount,
                data: datas,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    

    getColumns = () => {
        const { userId, curRole, isInvPM } = sessionStorage;
        const { head } = this.state;
        const splitString = fp.compose(
            fp.split(','),
            fp.defValue('')
        );
        const columns = [{
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            fixed: 'left',
            sorter: true,
            width: 160,
            render: (text, record) => {
                const { allowEnter, investigationId } = record;
                return (
                    allowEnter ?
                        <a onClick={() => this.selectInvestigation(investigationId)}>{text}</a>
                    :
                        text
                );
            }
        }, {
            title: '项目名称',
            dataIndex: 'investigationSpecialName',
            key: 'investigationSpecialName',
            sorter: true,
            width: 160,
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            sorter: true,
            width: 120,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            sorter: true,
            width: 120,
            render: (text, record) => {
                const { pmIds } = record;
                return (
                    (curRole == 'BO' || (curRole == 'PM' && (pmIds || '').indexOf(userId) >= 0)) ?
                        <a onClick={() => this.props.saveJdeCode(text)}>{text}</a>
                    :
                        text
                );
            }
        }, {
            title: '项目类型',
            dataIndex: 'investigationGlobalType',
            key: 'investigationGlobalType',
            width: 100,
            render: (text) => text ? GlobalType[text]: text,
        }, {
            title: '项目级别',
            dataIndex: 'levelName',
            key: 'levelName',
            width: 80,
        }, {
            title: '项目状态',
            dataIndex: 'invStatusShow',
            key: 'invStatusShow',
            width: 100,
        }, {
            title: '项目阶段',
            dataIndex: 'stageNames',
            key: 'stageNames',
            width: 100,
        }, {
            title: '项目分类',
            dataIndex: 'typeName',
            key: 'typeName',
            width: 100,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 100,
        }, {
            title: '疾病分类',
            dataIndex: 'diseaseClassName',
            key: 'diseaseClassName',
            width: 100,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 100,
        }, {
            title: '研究产品类型',
            dataIndex: 'investigationMedicineName',
            key: 'investigationMedicineName',
            width: 100,
            render: (text, record) => {
                const { researchProductTypeShow } = record;
                return researchProductTypeShow;
            }
        }, {
            title: '肿瘤治疗方式',
            dataIndex: 'treatmentMethodShow',
            key: 'treatmentMethodShow',
            width: 100,
        }, {
            title: '药物(疗法)分类/主要作用靶点',
            dataIndex: 'drugMainTargets',
            key: 'drugMainTargets',
            width: 120,
        }, {
            title: '研究药物通用名称/产品具体名称/技术名称',
            dataIndex: 'investigationMedicine',
            key: 'investigationMedicine',
            width: 140,
        }, {
            title: '给药方式',
            dataIndex: 'administrationModeShow',
            key: 'administrationModeShow',
            width: 100,
            render: (text, record) => {
                const { administrationModeRemark } = record;
                return administrationModeRemark ? `${text}(${administrationModeRemark})` : text;
            }
        }, {
            title: '项目分期',
            dataIndex: 'investigationByStageName',
            key: 'investigationByStageName',
            width: 100,
        }, {
            title: '受试者类型',
            dataIndex: 'testeeTypeName',
            key: 'testeeTypeName',
            width: 100,
        }, {
            title: '申办方',
            dataIndex: 'investigationSponsor',
            key: 'investigationSponsor',
            sorter: true,
            width: 160,
        }, {
            title: 'CRO',
            dataIndex: 'CRO',
            key: 'CRO',
            width: 160,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 100,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 140,
        }, {
            title: '项目性质',
            dataIndex: 'invNature',
            key: 'invNature',
            width: 80,
        }, {
            title: 'CDE登记号',
            dataIndex: 'cdeNum',
            key: 'cdeNum',
            width: 80,
        }, {
            title: '计收入确认方式',
            dataIndex: 'contractTypeName',
            key: 'contractTypeName',
            width: 80,
        }, {
            title: '合同额含税/人民币(元)',
            dataIndex: 'investigationContractAmount',
            key: 'investigationContractAmount',
            sorter: true,
            width: 160,
            render: text => format('money', text),
        }, {
            title: 'PM',
            dataIndex: 'PM',
            key: 'PM',
            width: 100,
        }];
        const newColumns = columns.filter(i => {
            const { isShow } = head.find(h => h.dataIndex === i.key) || {};
            return isShow === '1';
        });
        newColumns.unshift({
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 60,
        },{
            title: '项目识别码',
            dataIndex: 'investigationIdentifyCode',
            key: 'investigationIdentifyCode',
            fixed: 'left',
            width: 120,
        });
        newColumns.push({
            title: <div className="config_clm_oper"><span>操作</span><Icon onClick={() => this.configColumn()} type="setting" style={{ float: "right", fontSize: "18px", marginRight: "10px" }} /></div>,
            dataIndex: 'operation',
            key: 'operation',
            width: 140,
            fixed: 'right',
            render: (text, record) => {
                const { pmUserIds, paAndPmIds, paIds, pmIds, investigationId } = record;
                const configPA = fp.compose(
                    fp.contains(userId),
                    splitString
                )(pmUserIds);
                const paAndPmIdsArr = splitString(paAndPmIds);
                const delegateUser = paIds || pmIds;
                const paIdsArr = splitString(paIds);
                const pmIdsArr = splitString(pmIds);
                const isPAorPM = paAndPmIdsArr.includes(userId);
                const role = pmIdsArr.includes(userId) ? "PM" : paIdsArr.includes(userId) ? "PA" : "";
                const operationCorrespondRoles = new Map([
                    ['infoProcess', {
                        name: '项目信息和进展',
                        display: true,
                        editable: true,
                        event: () => this.props.showPreviewModal(investigationId),
                        roles: ['*'],
                    }],
                    ['confPro', {
                        name: '配置项目',
                        display: fp.contains(curRole, ['BO', 'CTA', 'PML']) || isPAorPM,
                        editable: true,
                        event: () => this.props.canEditByInvStatus(investigationId, () => this.props.toConfigInv(record, isPAorPM ? role : curRole)),
                        roles: ['*'],
                    }],
                    ['delegateUser', {
                        name: !delegateUser ? '委派人员' : '变更人员',
                        display: true,
                        editable: true,
                        event: () => this.props.canEditDelegateUserByInvStatus(investigationId, () => this.props.delegateUser(investigationId, delegateUser)),
                        roles: ['BO', 'CTA'],
                    }],
                    ['delete', {
                        name: '删除',
                        display: true,
                        editable: true,
                        event: () => this.props.del(investigationId),
                        roles: ['CTA'],
                    }],
                    ['configPA', {
                        name: '配置PA和协助项目成员',
                        display: fp.contains(curRole, ['PML']) || configPA,
                        editable: true,
                        event: () => this.props.canEditByInvStatus(investigationId, () => this.props.setPA(investigationId, 'PA')),
                        roles: ['PA', 'PM', 'CRC', 'CRCC', 'CRCM', 'BD', 'BDO', 'BDM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA'],
                    }],
                    ['configBD', {
                        name: '配置BD',
                        display: true,
                        editable: true,
                        event: () => this.props.canEditByInvStatus(investigationId, () => this.props.setPA(investigationId, 'BD')),
                        roles: ['BDM'],
                    }],
                ]);
                return (
                    <span>
                        {   fp.compose(
                                fp.curry(cf.operationAuthByRole)(index => <span key={index} className="ant-divider" />),
                                fp.filter(i => !!i),
                                // 获取角色对应操作
                                fp.curry(cf.authDomList)(operationCorrespondRoles)
                            )(curRole)
                        }
                    </span>
                );
            }
        });
        return newColumns;
    }

    configColumn = () => {
        this.configColumnRef.show();
    }

    selectInvestigation = (investigationId) => {
        const { data } = this.state;
        const investigation = (data || []).find(i => i.investigationId == investigationId) || {};
        const { curRole } = sessionStorage;
        if (curRole == 'VP' || curRole == 'FIN') {
            this.props.selectRole(curRole, curRole, investigation);
        } else {
            this.props.getRoleListForInvestigation(investigation);
        }
    }

    render() {
        const { pagination: propPagination, sortParams, handleTableChange } = this.props
        const { data, loading, totalCount } = this.state;
        const pagination = Object.assign(propPagination, { total: totalCount });
        return (
            <div style={{marginTop: -16}}>
                <TableC
                    data={data}
                    scrollY={this.height}
                    loading={loading}
                    sortParams={sortParams}
                    pagination={pagination}
                    onChange={handleTableChange}
                    columns={this.getColumns()}
                    className="simpleInvestigationList"
                />
                <ConfigColumn ref={el => this.configColumnRef = el} loadData={this.queryHead} />
            </div>
        );
    }
}

export default list;


// WEBPACK FOOTER //
// ./src/components/investigation/Simple/List.js